// Dashboard "Six dimensions" panel. Compact bar list with band colour and
// 30-day delta. Reuses the existing .dim* classes inside a .dims-tight
// wrapper that narrows the column widths to fit the dashboard right column.

import type { Dimension, TrendDimension } from "../lib/api";
import { dimFillVariant } from "../lib/scoring";

const DIMENSION_LABEL: Record<Dimension, string> = {
  clarity: "Clarity",
  confidence: "Confidence",
  conciseness: "Conciseness",
  listening: "Listening",
  structure: "Structure",
  pacing: "Pacing",
};

const DIMENSION_ORDER: Dimension[] = [
  "clarity",
  "confidence",
  "conciseness",
  "listening",
  "structure",
  "pacing",
];

export function DimensionsPanel({ dimensions }: { dimensions: TrendDimension[] }) {
  const byName = new Map<Dimension, TrendDimension>();
  for (const d of dimensions) byName.set(d.name, d);

  return (
    <div className="kpanel">
      <div className="kpanel-h">
        <h3>Six dimensions</h3>
        <span className="meta">30d avg</span>
      </div>
      <div className="dims-tight">
        {DIMENSION_ORDER.map((name) => {
          const d = byName.get(name);
          const score = d?.average ?? 0;
          const delta = d?.deltaVsPrior;
          const variant = dimFillVariant(score);
          const fillClass = variant ? `dim-fill ${variant}` : "dim-fill";
          return (
            <div key={name} className="dim" style={{ ["--w" as string]: `${Math.round(score)}%` }}>
              <span className="dim-name">{DIMENSION_LABEL[name]}</span>
              <div className="dim-track">
                <div className={fillClass} />
              </div>
              <span className="dim-val">
                <span>{Math.round(score)}</span>
                {delta != null && Math.abs(delta) >= 0.5 ? (
                  <span className={`delta ${delta > 0 ? "up" : "down"}`}>
                    {delta > 0 ? "+" : "−"}
                    {Math.abs(Math.round(delta))}
                  </span>
                ) : null}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
